
import init, * as BeamtermModule from './beamterm_renderer.js';

// Initialization state
let initPromise = null;
let initialized = false;

// Helper to ensure initialization
async function ensureInit(wasmUrl) {
    if (!initialized) {
        if (!initPromise) {
            if (wasmUrl) {
                initPromise = init(wasmUrl);
            } else {
                // Auto-detect WASM URL
                let baseUrl = '';
                try {
                    if (typeof document !== 'undefined' && document.currentScript) {
                        baseUrl = document.currentScript.src.substring(0, document.currentScript.src.lastIndexOf('/'));
                    } else if (typeof location !== 'undefined') {
                        baseUrl = location.href.substring(0, location.href.lastIndexOf('/'));
                    }
                } catch (e) {
                    // Fallback to relative path
                }
                const autoWasmUrl = baseUrl ? baseUrl + '/beamterm_bg.wasm' : './beamterm_bg.wasm';
                initPromise = init(autoWasmUrl);
            }
        }
        await initPromise;
        initialized = true;
    }
}

// Create the Beamterm API object
const Beamterm = {
    async init(wasmUrl) {
        await ensureInit(wasmUrl);
        return this;
    },
    
    style() {
        if (!initialized) {
            throw new Error('Beamterm not initialized. Call await Beamterm.init() first.');
        }
        return BeamtermModule.style();
    },
    
    cell(symbol, style) {
        if (!initialized) {
            throw new Error('Beamterm not initialized. Call await Beamterm.init() first.');
        }
        return BeamtermModule.cell(symbol, style);
    },
    
    BeamtermRenderer: function(canvasId) {
        if (!initialized) {
            throw new Error('Beamterm not initialized. Call await Beamterm.init() first.');
        }
        return new BeamtermModule.BeamtermRenderer(canvasId);
    },
    
    CellStyle: function() {
        if (!initialized) {
            throw new Error('Beamterm not initialized. Call await Beamterm.init() first.');
        }
        return new BeamtermModule.CellStyle();
    },
    
    Cell: function(symbol, style) {
        if (!initialized) {
            throw new Error('Beamterm not initialized. Call await Beamterm.init() first.');
        }
        return new BeamtermModule.Cell(symbol, style);
    },

    CellQuery: function(mode) {
        if (!initialized) {
            throw new Error('Beamterm not initialized. Call await Beamterm.init() first.');
        }
        return new BeamtermModule.CellQuery(mode);
    },
    
    get SelectionMode() { 
        return initialized ? BeamtermModule.SelectionMode : undefined; 
    },
    
    get MouseEventType() { 
        return initialized ? BeamtermModule.MouseEventType : undefined; 
    },
    
    get MouseEvent() { 
        return initialized ? BeamtermModule.MouseEvent : undefined; 
    },
    
    get Batch() { 
        return initialized ? BeamtermModule.Batch : undefined; 
    },
    
    get Size() { 
        return initialized ? BeamtermModule.Size : undefined; 
    },
    
    version: '0.2.0',
    
    async createRenderer(canvasId) {
        await this.init();
        return new this.BeamtermRenderer(canvasId);
    },
    
    get initialized() { return initialized; },
    get module() { return initialized ? BeamtermModule : null; }
};

// Auto-initialize in browser
if (typeof window !== 'undefined') {
    // Start auto-init but don't block
    ensureInit().catch(err => {
        console.warn('Beamterm auto-initialization failed:', err);
        console.warn('Call await Beamterm.init() with correct WASM path if needed');
    });
}

export default Beamterm;
